var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataIsReady)?_c('div',{attrs:{"id":"app"}},[_c('title-setter',{attrs:{"title":_vm.congressName}}),(_vm.internetExplorer)?_c('internet-explorer'):_c('router-view')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }